import { Box } from '../../Box/Box';
import { useIcon } from '../../../hooks/useIcon';
import { IconProps } from '../types';
import { IconTriangleWarningSvg } from './IconTriangleWarningSvg';

export const IconTriangleWarning: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconTriangleWarningSvg} {...iconProps} />;
};
